import React, { useEffect, useRef } from 'react';
import { Hero } from './components/sections/Hero';
import { StatsBar } from './components/sections/StatsBar';
import { Problem } from './components/sections/Problem';
import { Solution } from './components/sections/Solution';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Identify } from './components/sections/Identify';
import { Tomos } from './components/sections/Tomos';
import { Bonos } from './components/sections/Bonos';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { AuthorMessage } from './components/sections/AuthorMessage';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchaseToast } from './components/PurchaseToast';
import { initMetaPixel } from './utils/pixel';
export function App() {
  const heroCtaRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-navy" data-id="element-0" data-mp="3rc9d24sih9w6">
      <main className="w-full overflow-x-hidden" data-id="element-1" data-mp="3rcsw5otwe4bs">
        <Hero ctaRef={heroCtaRef} data-id="element-2" data-mp="5orv1p50w72" />
        <StatsBar data-id="element-3" data-mp="4n5i12o8na1" />
        <Problem data-id="element-4" data-mp="56lvdcob3ly" />
        <Solution data-id="element-5" data-mp="7ssnarqpf34" />
        <BeforeAfter data-id="element-6" data-mp="2zld2jatxbhc2" />
        <Identify data-id="element-7" data-mp="2zlv32jnmchps" />
        <Tomos data-id="element-8" data-mp="2zmo4r67q0h12" />
        <Bonos data-id="element-9" data-mp="2zmwlj96ys6hj" />
        <Offer data-id="element-10" data-mp="2zng2amkvootz" />
        <Guarantee data-id="element-11" data-mp="33mf1dqjxhrdi" />
        <Testimonials data-id="element-12" data-mp="33lx02fiesmyq" />
        <AuthorMessage data-id="element-13" data-mp="33n6zb810016y" />
        <Faq data-id="element-14" data-mp="33ork45xig5rm" />
        <FinalCTA data-id="element-15" data-mp="38lro8basuyg3" />
      </main>
      <Footer data-id="element-16" data-mp="38li77d7qg1mj" />

      <FloatingCTA triggerRef={heroCtaRef} data-id="element-17" data-mp="38l05w267qx7r" />
      <PurchaseToast data-id="element-18" data-mp="3dkuv81acbeqp" />
    </div>;
}